import { useEffect } from 'react';

/** Calls `onClose` when Escape is pressed while the dialog is open. */
export const useEscapeToClose = (isOpen: boolean, onClose: () => void): void => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);
};
